import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Clients
export const getClients = async () => {
  const response = await axios.get(`${API}/clients`, { headers: getAuthHeader() });
  return response.data;
};

export const getPendingClients = async () => {
  const response = await axios.get(`${API}/clients/pending`, { headers: getAuthHeader() });
  return response.data;
};

export const createClient = async (clientData) => {
  const response = await axios.post(`${API}/clients`, clientData, { headers: getAuthHeader() });
  return response.data;
};

export const deleteClient = async (clientId) => {
  const response = await axios.delete(`${API}/clients/${clientId}`, { headers: getAuthHeader() });
  return response.data;
};

export const updateClientStatus = async (clientId, status) => {
  const response = await axios.put(`${API}/clients/${clientId}/status?status=${status}`, {}, { headers: getAuthHeader() });
  return response.data;
};

// Templates
export const getTemplates = async () => {
  const response = await axios.get(`${API}/templates`, { headers: getAuthHeader() });
  return response.data;
};

export const createTemplate = async (templateData) => {
  const response = await axios.post(`${API}/templates`, templateData, { headers: getAuthHeader() });
  return response.data;
};

export const updateTemplate = async (templateId, templateData) => {
  const response = await axios.put(`${API}/templates/${templateId}`, templateData, { headers: getAuthHeader() });
  return response.data;
};

export const deleteTemplate = async (templateId) => {
  const response = await axios.delete(`${API}/templates/${templateId}`, { headers: getAuthHeader() });
  return response.data;
};

// Connections
export const getConnections = async () => {
  const response = await axios.get(`${API}/connections`, { headers: getAuthHeader() });
  return response.data;
};

export const createConnection = async (connectionData) => {
  const response = await axios.post(`${API}/connections`, connectionData, { headers: getAuthHeader() });
  return response.data;
};

export const deleteConnection = async (connectionId) => {
  const response = await axios.delete(`${API}/connections/${connectionId}`, { headers: getAuthHeader() });
  return response.data;
};

// Analytics
export const getAnalyticsOverview = async () => {
  const response = await axios.get(`${API}/analytics/overview`, { headers: getAuthHeader() });
  return response.data;
};

export const getRecentActivity = async () => {
  const response = await axios.get(`${API}/analytics/recent-activity`, { headers: getAuthHeader() });
  return response.data;
};

// Review Requests
export const sendReviewRequests = async (clientIds = null, templateId = null) => {
  const params = new URLSearchParams();
  if (templateId) params.append('template_id', templateId);
  
  const response = await axios.post(
    `${API}/send-review-requests${params.toString() ? '?' + params.toString() : ''}`,
    clientIds,
    { headers: getAuthHeader() }
  );
  return response.data;
};

export const sendSingleRequest = async (clientId, templateId = null) => {
  const params = new URLSearchParams();
  if (templateId) params.append('template_id', templateId);
  
  const response = await axios.post(
    `${API}/send-single-request/${clientId}${params.toString() ? '?' + params.toString() : ''}`,
    {},
    { headers: getAuthHeader() }
  );
  return response.data;
};

// Settings
export const updateGoogleReviewLink = async (link) => {
  const response = await axios.put(
    `${API}/auth/google-review-link`,
    { google_review_link: link },
    { headers: getAuthHeader() }
  );
  return response.data;
};

export const getUserSettings = async () => {
  const response = await axios.get(`${API}/settings`, { headers: getAuthHeader() });
  return response.data;
};

export const updateResendSettings = async (settings) => {
  const response = await axios.put(`${API}/settings/resend`, settings, { headers: getAuthHeader() });
  return response.data;
};

export const updateStripeSettings = async (settings) => {
  const response = await axios.put(`${API}/settings/stripe`, settings, { headers: getAuthHeader() });
  return response.data;
};

export const updateShopifySettings = async (settings) => {
  const response = await axios.put(`${API}/settings/shopify`, settings, { headers: getAuthHeader() });
  return response.data;
};

// Reviews
export const getRecentReviews = async () => {
  const response = await axios.get(`${API}/reviews/recent`, { headers: getAuthHeader() });
  return response.data;
};

export const getAverageRating = async () => {
  const response = await axios.get(`${API}/reviews/average-rating`, { headers: getAuthHeader() });
  return response.data;
};

// Admin
export const adminGetUsers = async () => {
  const response = await axios.get(`${API}/admin/users`, { headers: getAuthHeader() });
  return response.data;
};

export const adminCreateUser = async (userData) => {
  const response = await axios.post(`${API}/admin/users`, userData, { headers: getAuthHeader() });
  return response.data;
};

export const adminUpdateUser = async (userId, userData) => {
  const response = await axios.put(`${API}/admin/users/${userId}`, userData, { headers: getAuthHeader() });
  return response.data;
};

export const adminDeleteUser = async (userId) => {
  const response = await axios.delete(`${API}/admin/users/${userId}`, { headers: getAuthHeader() });
  return response.data;
};

export const adminGetStats = async () => {
  const response = await axios.get(`${API}/admin/stats`, { headers: getAuthHeader() });
  return response.data;
};

// Password
export const changePassword = async (currentPassword, newPassword) => {
  const response = await axios.put(`${API}/auth/change-password`, {
    current_password: currentPassword,
    new_password: newPassword
  }, { headers: getAuthHeader() });
  return response.data;
};
